var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"rounded":"","color":"primary","small":_vm.small},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.label || 'Save')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }